(function (angular) {
	'use strict';

	angular.module('premiumWelcomeModule', [
		'collapseModule',
		'coreModule',
		'videoModule'
	]);
})(window.angular);